import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-rule',
  templateUrl: './delete-rule.component.html',
  styleUrls: ['./delete-rule.component.scss']
})
export class DeleteRuleComponent implements OnInit {

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
